import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { User } from '../_models';

@Injectable()
export class RoleGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const role: string = route.data.role;
    const user: User = JSON.parse(localStorage.getItem('currentUser'));
    if (user) {
      return user.role === role;
    }

    return false;
  }
}
